import React, {  PureComponent  } from 'react';
import { Collapse  } from 'antd';
import { invoicesTotal } from './graphicsData';
import CustomLineChart from '../_Generic/LineChart/index';
import { formatMoney } from '../../helpers';
import EmptyContent from './EmptyContent';
const { Panel } = Collapse;

class Payment extends PureComponent {	

	render() {
		if(!this.props.data)
			return <EmptyContent />;

		const { data, numberOfPayments, totalAmountPayments, numberOfPaymentsCanceled, numberOfPaymentsDuplicated } = this.props.data;		
		return (
			<Collapse accordion defaultActiveKey={['1']}>                
                <Panel header="Información de pagos" key="1">
                    <div className="box">
						<span className="label">Número de pagos</span>
						<span className="number-text">{numberOfPayments}</span>
					</div>					
					<div className="box">
						<span className="label">Pagos Cancelados</span>
						<span className="number-text">{numberOfPaymentsCanceled}</span>
					</div>
					<div className="box">
						<span className="label">Pagos Duplicados</span>
						<span className="number-text">{numberOfPaymentsDuplicated}</span>
					</div>
					<div className="box">
						<span className="label">Total</span>
						<span className="number-text">{formatMoney(totalAmountPayments)}</span>
					</div>
                </Panel>
				{
					this.props.data.data && 
					<Panel header="Cantidad de pagos" key="2">
						<CustomLineChart data={invoicesTotal(data)} dataKey="Cantidad" width={300} height={250} stroke="#65DD33" />
					</Panel>
				}
				{
					this.props.data.data && 
					<Panel header="Total de pagos" key="3">
						<CustomLineChart data={invoicesTotal(data)} width={300} height={250} stroke="#65DD33" />
					</Panel>
				}
            </Collapse>
		)
	}
}

export default Payment;